export default __webpack_public_path__ + "static/media/fairy.0febf46a.svg";